interface appData {
  footerText: any
  showProgress: boolean
  loadFlag: boolean

}

export const useAppStore = defineStore('app-store', {
  state: (): appData => {
    return {
      footerText: import.meta.env.VITE_COPYRIGHT_INFO,
      showProgress: true,
      loadFlag: true,
    }
  },
  actions: {

    /**
     * @description: 页面内容重载
     * @param {number} delay - 延迟毫秒数
     * @return {*}
     */
    async reloadPage(delay = 600) {
      this.loadFlag = false
      await nextTick()
      if (delay) {
        setTimeout(() => {
          this.loadFlag = true
        }, delay)
      }
      else {
        this.loadFlag = true
      }
    },

  },
  persist: {
    storage: localStorage,
  },
})
